import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app";

async function init() {
  const root = createRoot(document.getElementById("root"));
  const searchParams = new URLSearchParams(window.location.search);
  // "DSM_" prefix is needed for the backend to recognize it as a DSM user, instead of a bot
  const name = searchParams.get('name') || 'DSM_livekit-web-demo-dev';
  const room = searchParams.get('room') || 'quickstart-room';
  const getTokenUrl = new URL('/getToken', window.location.origin);
  getTokenUrl.searchParams.set('name', name);
  getTokenUrl.searchParams.set('room', room);
  const token = await fetch(getTokenUrl).then((res) => res.text());
  root.render(
    <StrictMode>
      <App
        serverUrl='wss://dasiotvideodev-hemnbsxr.livekit.cloud'
        token={token}
      />
    </StrictMode>
  );
}

init();
